import { FormControl } from '@angular/forms';

import { AuxIconName } from '@shared/components/icon/icon';
import { FormGroupTyped } from '@shared/utils/utils';

export enum SourceType {
  Averages = 'averages',
  Contracted = 'contracted',
  PatientVisits = 'patientVisits',
}

export interface ContractedInvestigatorAmountValues extends InvestigatorForecastTotals {
  invoiceablesPerc: number;
  invoiceablesToDate: number;
  otherInvoiceables: number;
  overheadInvoiceables: number;
  totalInvoiceables: number;
  totalVisitCosts: number;
  visitCostsToDate: number;
}

export type InvestigatorForecastForm = {
  averages: FormGroupTyped<SiteContractAveragesValues>;
  contracted: FormGroupTyped<ContractedInvestigatorAmountValues>;
  patientVisits: FormGroupTyped<PatientVisitsValues>;
  source: FormControl<null | SourceType>;
  vendorId: FormControl<null | string>;
};

export interface InvestigatorForecastTotals {
  avgPatientCost?: number;
  remainingAmount: number;
  spendToDateAmount: number;
  totalInvestigatorCosts: number;
}

export interface InvestigatorForecastValues {
  averages: SiteContractAveragesValues;
  contracted: ContractedInvestigatorAmountValues;
  patientVisits: PatientVisitsValues;
  source: null | SourceType;
  vendorId: null | string;
}

export interface PatientVisitsValues extends InvestigatorForecastTotals {
  averageCompletedPatientCost: number;
  currentDiscontinuedAmount: number;
  currentDiscontinuedPerc: number;
  currentEnrolledAmount: number;
  currentInvoiceablesPercent: number;
  differentPatientCost: number;

  forecastedRemainingInvestigatorCosts: number;
  forecastedRemainingInvoiceables: number;
  forecastedRemainingVisitCosts: number;
  invoiceablesDistribution: number;
  invoiceablesPerc: number;
  invoiceablesToDate: number;
  patientRemainingToDiscontinueAmount: number;
  patientRemainingToDiscontinueAmountLeft: number;
  remainingPatientsToDiscontinueCost: number;
  remainingPatientsToDiscontinuePerc: number;
  totalDiscontinued: number;

  totalDiscontinuedPerc: number;
  totalForecastedInvestigatorAmountThroughEndOfTrial: number;
  totalForecastedRemainingInvestigatorCosts: number;
  totalSpendToDate: number;
  visitCostsToDate: number;
}

export interface SiteContractAveragesValues extends InvestigatorForecastTotals {
  averagePatientCost: number;
  contractedSites: string;
  forecastedInvoiceables: number;
  forecastedVisitCosts: number;
  invoiceables: null | number;
  otherInvoiceablesPerc: number;
  overheadInvoiceablesPerc: number;
  totalForecastedPatients: number;
}

export interface Source {
  avgPatientCost?: number;
  forecastTotal?: number;
  icon?: AuxIconName;
  label: string;
  remaining?: number;
  spendToDate?: number;
  value: SourceType;
}
